import { NotificationId as Api } from '@tableau/api-internal-contract-js';
import { NotificationId as PL } from '../../gen-src/preslayer/Events';
import { PresLayerToExtensionsApiConverter } from './PresLayerToExtensionsApiConverter';
import { EventMappingRegistration, EventMappingRegistry, SharedEventMappingRegistryFactory } from './SharedEventMappingRegistryFactory';

export class EventMappingRegistryFactory {
  /**
   * Creates and populates a new EventMappingRegistry
   *
   * @returns {EventMappingRegistry}
   */
  public static createEventMappingRegistry(): EventMappingRegistry {
    const registry: EventMappingRegistry = SharedEventMappingRegistryFactory.createEventMappingRegistry();

    registry[PL.ExtensionDialogUpdate] = new EventMappingRegistration(
      PL.ExtensionDialogUpdate,
      Api.ExtensionDialogUpdate,
      PresLayerToExtensionsApiConverter.convertDialogUpdateEvent,
    );

    registry[PL.SettingsChanged] = new EventMappingRegistration(
      PL.SettingsChanged,
      Api.SettingsChanged,
      PresLayerToExtensionsApiConverter.convertSettingsChangedEvent,
    );

    registry[PL.ContextMenu] = new EventMappingRegistration(
      PL.ContextMenu,
      Api.ContextMenuClick,
      PresLayerToExtensionsApiConverter.convertContextMenuClickEvent,
    );

    registry[PL.WorksheetFormattingChanged] = new EventMappingRegistration(
      PL.WorksheetFormattingChanged,
      Api.WorksheetFormattingChanged,
      PresLayerToExtensionsApiConverter.convertWorksheetFormattingChangedPresModel,
    );

    registry[PL.WorkbookFormattingChanged] = new EventMappingRegistration(
      PL.WorkbookFormattingChanged,
      Api.WorkbookFormattingChanged,
      PresLayerToExtensionsApiConverter.convertWorkbookFormattingChangedPresModel,
    );

    registry[PL.DashboardLayoutChanged] = new EventMappingRegistration(
      PL.DashboardLayoutChanged,
      Api.DashboardLayoutChanged,
      PresLayerToExtensionsApiConverter.convertDashboardLayoutChangedEvent,
    );

    return registry;
  }
}
